{
  "COMPLEX": "Fideicomiso complejo",
  "SIMPLE": "Fideicomiso simple",
  "GRANTOR": "Fideicomiso otorgante"
}
